import { createContext, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearError, clearMessage, fetchFullMedia, removeBulkMedia, removeSingleMedia, updateMedia } from "../store-slice/media-slice";
import { useAuth } from "./AuthContext";
import { useToast } from "./ToastContext";

const DataContext = createContext(undefined);

export function useData() {
	const context = useContext(DataContext);
	if (context === undefined) {
		throw new Error('useData must be used within a DataProvider');
	}
	return context;
}
export function DataProvider({ children }) {
	const{user} = useAuth();
	const{toast} = useToast();
	const {
		isLoading:mediaLoading,
		medias,
		pagination:mediaPagination,
		media:mediaSingle,
		error:mediaError,
		message:mediaMessage
	} = useSelector(state=> state.media);
	const dispatch = useDispatch();
	const createNewMedia = (mediaData) => {
		dispatch(updateMedia(mediaData));
	};
	const deleteMedia = (id)=>{
		dispatch(removeSingleMedia(id));
	}
	const deleteBulkMedia = (selectedIds)=>{
		dispatch(removeBulkMedia(selectedIds));
	}
	const refreshAllMedia = (page = 1, limit = 10) => {
		dispatch(fetchFullMedia({ page, limit}));
	};
	useEffect(()=>{
		if(user){
			refreshAllMedia(1, 40);
		}
	},[user])
	useEffect(()=>{
		if(mediaError){
			toast(mediaError.type, mediaError.text);
			const timeOut = setTimeout(() => {
				dispatch(clearError());
			}, 1000);
			return () => clearTimeout(timeOut);
		}
	},[mediaError])
	useEffect(()=>{
		if(mediaMessage){
			toast(mediaMessage.type, mediaMessage.text);
			const timeOut = setTimeout(() => {
				dispatch(clearMessage());
			}, 1000);
			return () => clearTimeout(timeOut);
		}
	},[mediaMessage])

	return <DataContext.Provider value={{
		mediaLoading,
		medias,
		mediaPagination,
		mediaSingle,
		createNewMedia,
		deleteMedia,
		deleteBulkMedia,
		refreshAllMedia
	}}>{children}</DataContext.Provider>;
}
